module.exports = __webpack_public_path__ + "static/media/about-icon-light.9007264b.svg";